// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KQzF","rootNoMargin":"styles_rootNoMargin__2J9ZU"};